export default __webpack_public_path__ + "static/media/logo-xl-1920w.1dcc1cfa.avif";